import type {
  CommonNavContent,
  CommonNavLink,
} from 'client-site-chrome-ui/content/types/commonNavigation';

export const transformToSEOLinks = (navData: CommonNavContent) => {
  try {
    const links: CommonNavLink[] = [];
    const uniqueURLs = new Set<string>();

    const addIfNotExists = (link: CommonNavLink) => {
      if (!uniqueURLs.has(link.url)) {
        uniqueURLs.add(link.url);
        links.push({ title: link.title, url: link.url });
      }
    };

    navData.l1_navigation.forEach((level1) => {
      level1.l1_navigation_link.forEach(addIfNotExists);

      level1.l2_navigation.forEach((level2) => {
        level2.l2_navigation_link.forEach(addIfNotExists);

        level2.l3_navigation.forEach((level3) => {
          level3.l3_navigation_link.forEach(addIfNotExists);
        });
      });
    });

    return links;
  } catch (error) {
    return [];
  }
};
